// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Asynchronously wait for a specified number of milliseconds.
export const delay = async (milliseconds: number) => new Promise((resolve) => setTimeout(resolve, milliseconds));
